import { Lock, BarChart3, MessageCircle } from 'lucide-react';
import { useState } from 'react';
import TemporaryAdminAccessModal from './TemporaryAdminAccessModal';

export default function Footer() {
    const [showAdminModal, setShowAdminModal] = useState(false);

    const handleAnalyticsDashboard = () => {
        const analyticsSection = document.getElementById('analytics-dashboard-section');
        if (analyticsSection) {
            analyticsSection.scrollIntoView({ behavior: 'smooth' });
        }
    };

    const handleDiscord = () => {
        // KawSwap Discord Server - Server ID: 1460231619339227230
        // Permanent invite link: https://discord.gg/T6HSb8eZ8G
        const discordInviteLink = 'https://discord.gg/T6HSb8eZ8G';
        window.open(discordInviteLink, '_blank', 'noopener,noreferrer');
    };

    return (
        <>
            <footer className="border-t border-border bg-card/30 backdrop-blur-sm mt-auto">
                <div className="container mx-auto px-4 py-8">
                    <div className="flex flex-col md:flex-row items-center justify-between gap-4">
                        <div className="flex items-center">
                            <span className="font-semibold text-lg">KawSwap</span>
                        </div>
                        
                        <div className="flex items-center gap-4 text-sm text-muted-foreground">
                            <span>© 2025 KawSwap. All rights reserved.</span>
                            <button
                                onClick={handleDiscord}
                                className="flex items-center gap-1 hover:text-primary transition-colors"
                                aria-label="Join Discord"
                            >
                                <MessageCircle className="h-4 w-4" />
                                <span className="hidden sm:inline">Discord</span>
                            </button>
                            <button
                                onClick={handleAnalyticsDashboard}
                                className="flex items-center gap-1 hover:text-primary transition-colors"
                                aria-label="View Analytics"
                            >
                                <BarChart3 className="h-4 w-4" />
                                <span className="hidden sm:inline">Analytics</span>
                            </button>
                            <button
                                onClick={() => setShowAdminModal(true)}
                                className="p-1 hover:text-primary transition-colors"
                                aria-label="Admin Access"
                                title="Admin Access"
                            >
                                <Lock className="h-4 w-4" />
                            </button>
                        </div>
                    </div>
                </div>
            </footer>

            <TemporaryAdminAccessModal 
                open={showAdminModal} 
                onOpenChange={setShowAdminModal} 
            />
        </>
    );
}
